// extracted by mini-css-extract-plugin
export default {"NotFoundLayout":"iXwp1","NotFoundLayout__content":"qCsHt","NotFoundLayout__warning":"_an0r","NotFoundLayout__title":"bUFsb","NotFoundLayout__btn":"geJTK"};